// extracted by mini-css-extract-plugin
module.exports = {"events_list":"Homepage_events_list__LkfVB","title":"Homepage_title__13_fe"};